import type { IconGlyph } from '../icon';

/**
 * Tractie `close` glyph (extra small, 16×16).
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/xs/close.jsx`.
 * Verbatim copy of the SVG `d` attribute.
 */
export const iconCloseXs: IconGlyph = {
  name: 'close-xs',
  path: 'M8.7 8.01h.02l3.15-3.15c.2-.2.2-.51 0-.71s-.51-.2-.71 0L8.01 7.3 4.86 4.15c-.2-.2-.51-.2-.71 0s-.2.51 0 .71L7.3 8.01l-3.15 3.15c-.2.2-.2.51 0 .71a.485.485 0 0 0 .7 0L8 8.72l3.15 3.15a.485.485 0 0 0 .7 0c.2-.2.2-.51 0-.71z',
  viewBox: 16,
};
